import React from 'react';
import { Treemap, ResponsiveContainer, Tooltip } from 'recharts';
import StatisticsGlassCard from './StatisticsGlassCard';
import StatisticsDesktopSectionHeader from './StatisticsDesktopSectionHeader';
import { STATS_ICONS } from './statisticsAssets';
import useChartContainerReady from './useChartContainerReady';

const TREEMAP_COLORS = [
    '#354F38', '#4A7A50', '#5E9B63', '#72BC77', '#86D38B',
    '#9CDBA1', '#B5E6B8', '#CFf0D0',
];

function CustomTreemapContent({ root, depth, x, y, width, height, index, name, size }) {
    if (width < 4 || height < 4) return null;
    const color = TREEMAP_COLORS[index % TREEMAP_COLORS.length];
    const showLabel = width > 40 && height > 30;

    return (
        <g>
            <rect
                x={x}
                y={y}
                width={width}
                height={height}
                rx={6}
                ry={6}
                style={{
                    fill: color,
                    stroke: '#fff',
                    strokeWidth: 2,
                    opacity: 0.9,
                }}
            />
            {showLabel && (
                <>
                    <text
                        x={x + width / 2}
                        y={y + height / 2 - 6}
                        textAnchor="middle"
                        fill="#fff"
                        fontSize={11}
                        fontWeight={700}
                    >
                        {name}
                    </text>
                    <text
                        x={x + width / 2}
                        y={y + height / 2 + 10}
                        textAnchor="middle"
                        fill="rgba(255,255,255,0.8)"
                        fontSize={13}
                        fontWeight={900}
                    >
                        {size}명
                    </text>
                </>
            )}
        </g>
    );
}

export default function StatisticsDesktopGradeTreemapCard({
    gradeTreemapStats,
    isEditMode,
    longPressHandlers,
}) {
    const { containerRef, isReady } = useChartContainerReady();
    const totalStudents = gradeTreemapStats.reduce((acc, d) => acc + d.size, 0);

    return (
        <StatisticsGlassCard className="h-full p-5 flex flex-col" {...longPressHandlers} isEditMode={isEditMode}>
            <StatisticsDesktopSectionHeader
                iconSrc={STATS_ICONS.people}
                title="부서/직분 분포"
                badge={`${totalStudents}명`}
            />

            <div ref={containerRef} className="flex-1 min-h-[180px] min-w-0">
                {gradeTreemapStats.length > 0 ? (
                    isReady ? (
                        <ResponsiveContainer width="100%" height="100%">
                            <Treemap
                                data={gradeTreemapStats}
                                dataKey="size"
                                aspectRatio={4 / 3}
                                content={<CustomTreemapContent />}
                                animationDuration={800}
                            >
                                <Tooltip
                                    contentStyle={{
                                        backgroundColor: '#fff',
                                        border: '1px solid #E5E7EB',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                                        padding: '8px 12px',
                                        fontSize: '12px',
                                        fontWeight: 700,
                                    }}
                                    formatter={(value, name) => [`${value}명`, name]}
                                />
                            </Treemap>
                        </ResponsiveContainer>
                    ) : null
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-300 font-bold">
                        <div className="text-center">
                            <div className="text-3xl mb-2">🗂️</div>
                            <p className="text-sm">분포 데이터가 없습니다</p>
                        </div>
                    </div>
                )}
            </div>
        </StatisticsGlassCard>
    );
}
